export const GAME_TYPES = {
  BRAZILIAN_CHECKERS: "brazilian_checkers",
  SPANISH_CHECKERS: "spanish_checkers",
  ARUBASTINI: "arubastini",
  LASTCARD: "lastcard",
}

export const SUPPORTED_GAME_TYPES = [
  GAME_TYPES.BRAZILIAN_CHECKERS,
  GAME_TYPES.SPANISH_CHECKERS,
  GAME_TYPES.LASTCARD,
  GAME_TYPES.ARUBASTINI,
]

export const PLAY_MODES = {
  ONLINE: "online", //online mode
  LOCAL: "local", //local or offline mode
}

export function getCurrentTimestamp() {
  return Math. round(Date. now() / 1000);
}
